/*
 *
 * Survey actions
 *
 */

import {
  GET_SURVEY_WATCHER,
  GET_SURVEY_SUCCESS,
  GET_SURVEY_FAILED,
  UPDATE_SURVEY_WATCHER,
  UPDATE_SURVEY_SUCCESS,
  UPDATE_SURVEY_FAILED,
  DELETE_SURVEY_WATCHER,
  DELETE_SURVEY_SUCCESS,
  DELETE_SURVEY_FAILED,
  DELETE_ALL_QUESTIONS_WATCHER,
  DELETE_ALL_QUESTIONS_SUCCESS,
  DELETE_ALL_QUESTIONS_FAILED,
  UPDATE_DIMENSION_WATCHER,
  UPDATE_DIMENSION_SUCCESS,
  UPDATE_DIMENSION_FAILED,
  GET_DIMENSIONS_QUESTION_WATCHER,
  GET_DIMENSIONS_QUESTION_SUCCESS,
  GET_DIMENSIONS_QUESTION_FAILED,
  CREATE_QUESTION_WATCHER,
  CREATE_QUESTION_SUCCESS,
  CREATE_QUESTION_FAILED,
  UPDATE_QUESTION_WATCHER,
  UPDATE_QUESTION_SUCCESS,
  UPDATE_QUESTION_FAILED,
  GET_QUESTION_WATCHER,
  GET_QUESTION_SUCCESS,
  GET_QUESTION_FAILED,
  GET_QUESTION_TYPES_WATCHER,
  GET_QUESTION_TYPES_SUCCESS,
  GET_QUESTION_TYPES_FAILED,
  GET_SURVEY_ENPS_WATCHER,
  GET_SURVEY_ENPS_SUCCESS,
  GET_SURVEY_ENPS_FAILED,
  GET_DIMENSION_WATCHER,
  GET_DIMENSION_SUCCESS,
  GET_DIMENSION_FAILED,
  GET_SURVEY_QUALITATIVE_WATCHER,
  GET_SURVEY_QUALITATIVE_SUCCESS,
  GET_SURVEY_QUALITATIVE_FAILED,
  UPDATE_QUESTIONDIMENSION_WATCHER,
  UPDATE_QUESTIONDIMENSION_SUCCESS,
  UPDATE_QUESTIONDIMENSION_FAILED,
  DELETE_QUESTION_WATCHER,
  DELETE_QUESTION_SUCCESS,
  DELETE_QUESTION_FAILED,
  UPDATE_QUALITATIVE_WATCHER,
  UPDATE_QUALITATIVE_SUCCESS,
  UPDATE_QUALITATIVE_FAILED,
  GET_CONFIG_SURVEY_WATCHER,
  GET_CONFIG_SURVEY_SUCCESS,
  GET_CONFIG_SURVEY_FAILED,
  UPDATE_CONFIG_SURVEY_WATCHER,
  UPDATE_CONFIG_SURVEY_SUCCESS,
  UPDATE_CONFIG_SURVEY_FAILED,
  DOWNLOAD_SURVEY_WATCHER,
  DOWNLOAD_SURVEY_SUCCESS,
  DOWNLOAD_SURVEY_FAILED,
  GET_QUESTIONS_WATCHER,
  GET_QUESTIONS_SUCCESS,
  GET_QUESTIONS_FAILED,
  SEND_EMAIL_PREVIEW_SURVERY_WATCHER,
  SEND_EMAIL_PREVIEW_SURVERY_SUCCESS,
  SEND_EMAIL_PREVIEW_SURVERY_FAILED,
  UPLOAD_BG_IMAGE_WATCHER,
  UPLOAD_BG_IMAGE_SUCCESS,
  UPLOAD_BG_IMAGE_FAILED,
  UPLOAD_LOGO_WATCHER,
  UPLOAD_LOGO_SUCCESS,
  UPLOAD_LOGO_FAILED,
  GET_QUESTION_MULTIPLE_CHOICE_WATCHER,
  GET_QUESTION_MULTIPLE_CHOICE_SUCCESS,
  GET_QUESTION_MULTIPLE_CHOICE_FAILED,
  GET_SEGMENTS_WATCHER,
  GET_SEGMENTS_SUCCESS,
  GET_SEGMENTS_FAILED,
  GET_SURVEY_TYPES_WATCHER,
  GET_SURVEY_TYPES_SUCCESS,
  GET_SURVEY_TYPES_FAILED,
  GET_SCOPE_TYPES_WATCHER,
  GET_SCOPE_TYPES_SUCCESS,
  GET_SCOPE_TYPES_FAILED,
} from "./constants"

// UPLOAD LOGO
export function uploadLogoWatcher(payload) {
  return {
    type: UPLOAD_LOGO_WATCHER,
    payload,
  }
}

export function uploadLogoSuccess(payload) {
  return {
    type: UPLOAD_LOGO_SUCCESS,
    payload,
  }
}

export function uploadLogoFailed(payload) {
  return {
    type: UPLOAD_LOGO_FAILED,
    payload,
  }
}

// UPLOAD BG IMAGE
export function uploadBgImageWatcher(payload) {
  return {
    type: UPLOAD_BG_IMAGE_WATCHER,
    payload,
  }
}

export function uploadBgImageSuccess(payload) {
  return {
    type: UPLOAD_BG_IMAGE_SUCCESS,
    payload,
  }
}

export function uploadBgImageFailed(payload) {
  return {
    type: UPLOAD_BG_IMAGE_FAILED,
    payload,
  }
}

// GET QUESTIONS
export function getQuestionsWatcher(payload) {
  return {
    type: GET_QUESTIONS_WATCHER,
    payload,
  }
}

export function getQuestionsSuccess(payload) {
  return {
    type: GET_QUESTIONS_SUCCESS,
    payload,
  }
}

export function getQuestionsFailed(payload) {
  return {
    type: GET_QUESTIONS_FAILED,
    payload,
  }
}

// DOWNLOAD SURVEY
export function downloadSurveyWatcher(payload) {
  return {
    type: DOWNLOAD_SURVEY_WATCHER,
    payload,
  }
}

export function downloadSurveySuccess(payload) {
  return {
    type: DOWNLOAD_SURVEY_SUCCESS,
    payload,
  }
}

export function downloadSurveyFailed(payload) {
  return {
    type: DOWNLOAD_SURVEY_FAILED,
    payload,
  }
}

// GET CONFIG SURVEY
export function updateConfigSurveyWatcher(payload) {
  return {
    type: UPDATE_CONFIG_SURVEY_WATCHER,
    payload,
  }
}

export function updateConfigSurveySuccess(payload) {
  return {
    type: UPDATE_CONFIG_SURVEY_SUCCESS,
    payload,
  }
}

export function updateConfigSurveyFailed(payload) {
  return {
    type: UPDATE_CONFIG_SURVEY_FAILED,
    payload,
  }
}

// GET CONFIG SURVEY
export function getConfigSurveyWatcher(payload) {
  return {
    type: GET_CONFIG_SURVEY_WATCHER,
    payload,
  }
}

export function getConfigSurveySuccess(payload) {
  return {
    type: GET_CONFIG_SURVEY_SUCCESS,
    payload,
  }
}

export function getConfigSurveyFailed(payload) {
  return {
    type: GET_CONFIG_SURVEY_FAILED,
    payload,
  }
}

// UPDATE QUALITATIVE
export function updateQualitativeWatcher(payload) {
  return {
    type: UPDATE_QUALITATIVE_WATCHER,
    payload,
  }
}

export function updateQualitativeSuccess(payload) {
  return {
    type: UPDATE_QUALITATIVE_SUCCESS,
    payload,
  }
}

export function updateQualitativeFailed(payload) {
  return {
    type: UPDATE_QUALITATIVE_FAILED,
    payload,
  }
}

// DELETE QUESTION
export function deleteQuestionWatcher(payload) {
  return {
    type: DELETE_QUESTION_WATCHER,
    payload,
  }
}

export function deleteQuestionSuccess(payload) {
  return {
    type: DELETE_QUESTION_SUCCESS,
    payload,
  }
}

export function deleteQuestionFailed(payload) {
  return {
    type: DELETE_QUESTION_FAILED,
    payload,
  }
}

// UPDATE QUESTIONDIMENSION
export function updateQuestionDimensionWatcher(payload) {
  return {
    type: UPDATE_QUESTIONDIMENSION_WATCHER,
    payload,
  }
}

export function updateQuestionDimensionSuccess(payload) {
  return {
    type: UPDATE_QUESTIONDIMENSION_SUCCESS,
    payload,
  }
}

export function updateQuestionDimensionFailed(payload) {
  return {
    type: UPDATE_QUESTIONDIMENSION_FAILED,
    payload,
  }
}

// GET DIMENSION
export function getSurveyQualitativeWatcher(payload) {
  return {
    type: GET_SURVEY_QUALITATIVE_WATCHER,
    payload,
  }
}

export function getSurveyQualitativeSuccess(payload) {
  return {
    type: GET_SURVEY_QUALITATIVE_SUCCESS,
    payload,
  }
}

export function getSurveyQualitativeFailed(payload) {
  return {
    type: GET_SURVEY_QUALITATIVE_FAILED,
    payload,
  }
}

// GET DIMENSION
export function getDimensionWatcher(payload) {
  return {
    type: GET_DIMENSION_WATCHER,
    payload,
  }
}

export function getDimensionSuccess(payload) {
  return {
    type: GET_DIMENSION_SUCCESS,
    payload,
  }
}

export function getDimensionFailed(payload) {
  return {
    type: GET_DIMENSION_FAILED,
    payload,
  }
}

// GET SURVEY ENPS
export function getSurveyEnpsWatcher(payload) {
  return {
    type: GET_SURVEY_ENPS_WATCHER,
    payload,
  }
}

export function getSurveyEnpsSuccess(payload) {
  return {
    type: GET_SURVEY_ENPS_SUCCESS,
    payload,
  }
}

export function getSurveyEnpsFailed(payload) {
  return {
    type: GET_SURVEY_ENPS_FAILED,
    payload,
  }
}

// GET QUESTION TYPES
export function getQuestionWatcher(payload) {
  return {
    type: GET_QUESTION_WATCHER,
    payload,
  }
}

export function getQuestionSuccess(payload) {
  return {
    type: GET_QUESTION_SUCCESS,
    payload,
  }
}

export function getQuestionFailed(payload) {
  return {
    type: GET_QUESTION_FAILED,
    payload,
  }
}

// GET QUESTION TYPES
export function getQuestionTypesWatcher(payload) {
  return {
    type: GET_QUESTION_TYPES_WATCHER,
    payload,
  }
}

export function getQuestionTypesSuccess(payload) {
  return {
    type: GET_QUESTION_TYPES_SUCCESS,
    payload,
  }
}

export function getQuestionTypesFailed(payload) {
  return {
    type: GET_QUESTION_TYPES_FAILED,
    payload,
  }
}

// CREATE QUESTION
export function createQuestionWatcher(payload) {
  return {
    type: CREATE_QUESTION_WATCHER,
    payload,
  }
}

export function createQuestionSuccess(payload) {
  return {
    type: CREATE_QUESTION_SUCCESS,
    payload,
  }
}

export function createQuestionFailed(payload) {
  return {
    type: CREATE_QUESTION_FAILED,
    payload,
  }
}

// UPDATE QUESTION
export function updateQuestionWatcher(payload) {
  return {
    type: UPDATE_QUESTION_WATCHER,
    payload,
  }
}

export function updateQuestionSuccess(payload) {
  return {
    type: UPDATE_QUESTION_SUCCESS,
    payload,
  }
}

export function updateQuestionFailed(payload) {
  return {
    type: UPDATE_QUESTION_FAILED,
    payload,
  }
}

// GET DIMENSIONS QUESTION
export function getDimensionsQuestionWatcher(payload) {
  return {
    type: GET_DIMENSIONS_QUESTION_WATCHER,
    payload,
  }
}

export function getDimensionsQuestionSuccess(payload) {
  return {
    type: GET_DIMENSIONS_QUESTION_SUCCESS,
    payload,
  }
}

export function getDimensionsQuestionFailed(payload) {
  return {
    type: GET_DIMENSIONS_QUESTION_FAILED,
    payload,
  }
}

// GET SURVEYS TEMPLATE
export function updateDimensionWatcher(payload) {
  return {
    type: UPDATE_DIMENSION_WATCHER,
    payload,
  }
}

export function updateDimensionSuccess(payload) {
  return {
    type: UPDATE_DIMENSION_SUCCESS,
    payload,
  }
}

export function updateDimensionFailed(payload) {
  return {
    type: UPDATE_DIMENSION_FAILED,
    payload,
  }
}

// GET SURVEY
export function getSurveyWatcher(payload) {
  return {
    type: GET_SURVEY_WATCHER,
    payload,
  }
}

export function getSurveySuccess(payload) {
  return {
    type: GET_SURVEY_SUCCESS,
    payload,
  }
}

export function getSurveyFailed(payload) {
  return {
    type: GET_SURVEY_FAILED,
    payload,
  }
}

// UPDATE SURVEY
export function updateSurveyWatcher(payload) {
  return {
    type: UPDATE_SURVEY_WATCHER,
    payload,
  }
}

export function updateSurveySuccess(payload) {
  return {
    type: UPDATE_SURVEY_SUCCESS,
    payload,
  }
}

export function updateSurveyFailed(payload) {
  return {
    type: UPDATE_SURVEY_FAILED,
    payload,
  }
}

// DELETE SURVEY
export function deleteSurveyWatcher(payload) {
  return {
    type: DELETE_SURVEY_WATCHER,
    payload,
  }
}

export function deleteSurveySuccess(payload) {
  return {
    type: DELETE_SURVEY_SUCCESS,
    payload,
  }
}

export function deleteSurveyFailed(payload) {
  return {
    type: DELETE_SURVEY_FAILED,
    payload,
  }
}

// DELETE ALL QUESTIONS
export function deleteAllQuestionsWatcher(payload) {
  return {
    type: DELETE_ALL_QUESTIONS_WATCHER,
    payload,
  }
}

export function deleteAllQuestionsSuccess(payload) {
  return {
    type: DELETE_ALL_QUESTIONS_SUCCESS,
    payload,
  }
}

export function deleteAllQuestionsFailed(payload) {
  return {
    type: DELETE_ALL_QUESTIONS_FAILED,
    payload,
  }
}

export const sendEmailPreviewSurvey = (payload) => {
  return {
    type: SEND_EMAIL_PREVIEW_SURVERY_WATCHER,
    payload,
  }
}

export const sendEmailPreviewSurveySuccess = (payload) => {
  return {
    type: SEND_EMAIL_PREVIEW_SURVERY_SUCCESS,
    payload,
  }
}

export const sendEmailPreviewSurveyFailed = () => {
  return { type: SEND_EMAIL_PREVIEW_SURVERY_FAILED }
}

export function getQuestionsMultipleChoiceWatcher(payload) {
  return {
    type: GET_QUESTION_MULTIPLE_CHOICE_WATCHER,
    payload,
  }
}

export function getQuestionsMultipleChoiceSuccess(payload) {
  return {
    type: GET_QUESTION_MULTIPLE_CHOICE_SUCCESS,
    payload,
  }
}

export function getQuestionsMultipleChoiceFailed(payload) {
  return {
    type: GET_QUESTION_MULTIPLE_CHOICE_FAILED,
    payload,
  }
}

export function getSegmentsWatcher(payload) {
  return {
    type: GET_SEGMENTS_WATCHER,
    payload,
  }
}

export function getSegmentsSuccess(payload) {
  return {
    type: GET_SEGMENTS_SUCCESS,
    payload,
  }
}

export function getSegmentsFailed(payload) {
  return {
    type: GET_SEGMENTS_FAILED,
    payload,
  }
}

export function getSurveyTypesWatcher(payload) {
  return {
    type: GET_SURVEY_TYPES_WATCHER,
    payload,
  }
}

export function getSurveyTypesSuccess(payload) {
  return {
    type: GET_SURVEY_TYPES_SUCCESS,
    payload,
  }
}

export function getSurveyTypesFailed(payload) {
  return {
    type: GET_SURVEY_TYPES_FAILED,
    payload,
  }
}

export function getScopeTypesWatcher(payload) {
  return {
    type: GET_SCOPE_TYPES_WATCHER,
    payload,
  }
}

export function getScopeTypesSuccess(payload) {
  return {
    type: GET_SCOPE_TYPES_SUCCESS,
    payload,
  }
}

export function getScopeTypesFailed(payload) {
  return {
    type: GET_SCOPE_TYPES_FAILED,
    payload,
  }
}
